import { render } from "./NavigationSidebar.vue?vue&type=template&id=34eb48eb&scoped=true"
import script from "./NavigationSidebar.vue?vue&type=script&lang=js"
export * from "./NavigationSidebar.vue?vue&type=script&lang=js"

import "./NavigationSidebar.vue?vue&type=style&index=0&id=34eb48eb&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-34eb48eb"

export default script